import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

const ParticleBackground = React.memo(() => {
    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine);
    }, []);

    const options = useMemo(() => ({
        fullScreen: false,
        fpsLimit: 30,
        particles: {
            number: {
                value: 30,
                density: {
                    enable: true,
                    area: 1200,
                },
            },
            color: {
                value: '#6366f1',
            },
            shape: {
                type: 'circle',
            },
            opacity: {
                value: 0.25,
            },
            size: {
                value: { min: 1, max: 2.5 },
            },
            move: {
                enable: true,
                speed: 0.3,
                direction: 'none',
                random: true,
                straight: false,
                outModes: {
                    default: 'out',
                },
            },
            links: {
                enable: false,
            },
        },
        interactivity: {
            events: {
                onHover: {
                    enable: false,
                },
            },
        },
        detectRetina: false,
    }), []);

    return (
        <ParticleWrapper>
            <Particles
                id="hero-particles"
                init={particlesInit}
                options={options}
            />
        </ParticleWrapper>
    );
});

const ParticleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  will-change: auto;
  
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
`;

export default ParticleBackground;
